<template>
  <v-layout>
    <v-col cols :sm="12" class="px-0 pt-5">
      <v-form v-model="Setting.isValid" ref="form">
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-datePickerRange
                  label="Time Show Banner"
                  :rules="[Rules.required]"
                  v-model="Setting.obj.opt.dateRange"
                />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-datePickerRange
                  label="Time Active"
                  :rules="[Rules.required]"
                  v-model="Setting.obj.opt.activeDates"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Setting.obj.opt.eventUrl"
                >
                  <template #label>
                    Event Url
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Setting.obj.opt.officialId"
                >
                  <template #label>
                    Lomo Official ID
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Setting.obj.opt.supportId"
                >
                  <template #label>
                    Lomo Support ID
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-upload
                  :size="200"
                  class="mb-3"
                  label="Banner"
                  v-model="Setting.obj.opt.bannerEventImage"
                  :rules="[Rules.required]"
                />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-upload
                  :size="200"
                  class="mb-3"
                  label="Shortcut"
                  v-model="Setting.obj.opt.iconEventImage"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="2" class="py-0">
                <h4 class="heading">Bear:</h4>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Setting.obj.opt.bear.spin"
                >
                  <template #label>
                    Number of Turn
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Setting.obj.opt.bear.check"
                >
                  <template #label>
                    Condition
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="2" class="py-0">
                <h4 class="heading">Favorite:</h4>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Setting.obj.opt.favorite.spin"
                >
                  <template #label>
                    Number of Turn
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Setting.obj.opt.favorite.check"
                >
                  <template #label>
                    Condition
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="2" class="py-0">
                <h4 class="heading">Checkin:</h4>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Setting.obj.opt.checkin.spin"
                >
                  <template #label>
                    Number of Turn
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :disabled="true"
                  v-model="Setting.obj.opt.checkin.check"
                >
                  <template #label>
                    Condition
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="2" class="py-0">
                <h4 class="heading">Follow Official:</h4>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Setting.obj.opt.follow_official.spin"
                >
                  <template #label>
                    Number of Turn
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :disabled="true"
                  v-model="Setting.obj.opt.follow_official.check"
                >
                  <template #label>
                    Condition
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="2" class="py-0">
                <h4 class="heading">Follow Support:</h4>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Setting.obj.opt.follow_support.spin"
                >
                  <template #label>
                    Number of Turn
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="5" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :disabled="true"
                  v-model="Setting.obj.opt.follow_support.check"
                >
                  <template #label>
                    Condition
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!Setting.isValid"
              @click="_fnUpdate()"
              >{{ $t(`table.update`) }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "Setting",
  }),
  methods: {
    _fnUpdate() {
      this.fnPut({
        url: `/v1/admin/setting/${this[this.model].obj.type}`,
        model: this.model,
      });
    },
  },
};
</script>
